var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFishing1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fishing 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2969 0C15.7461 0 14.4844 1.26169 14.4844 2.8125C14.4844 4.03467 15.2682 5.0767 16.3594 5.46375V16.8281C16.3594 19.7489 13.9832 22.125 11.0625 22.125C8.14177 22.125 5.76562 19.7489 5.76562 16.8281H9.04688L3.89062 11.6719V16.8281C3.89062 20.7827 7.10794 24 11.0625 24C15.0171 24 18.2344 20.7827 18.2344 16.8281V5.46375C19.3255 5.0767 20.1094 4.03467 20.1094 2.8125C20.1094 1.26169 18.8477 0 17.2969 0ZM17.2969 3.75C16.7799 3.75 16.3594 3.32944 16.3594 2.8125C16.3594 2.29556 16.7799 1.875 17.2969 1.875C17.8138 1.875 18.2344 2.29556 18.2344 2.8125C18.2344 3.32944 17.8138 3.75 17.2969 3.75Z",
    fill: "#D9EEFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishing1);
export default __webpack_public_path__ + "static/media/fishing 1.61a308ac51bcbf2c6a7d7fb76e09b075.svg";
export { ForwardRef as ReactComponent };